import React, { Component } from 'react'
import { PetBestInsuranceCard, Steps, PageContent  } from "../../../UI-Component-Library";
import axios from "../../../custom-axios";
import { ApiConstants } from '../../../utils/api-constants';
import { LoadMask } from '../../../utils/loadmask.util';
import { showButtonLoader, hideButtonLoader } from '../../../utils/buttonLoader-util';
import { AppUtils } from '../../../utils/app-utils';
import SpreedlyPayment from './spreedly';

class PetBestInsuranceComponent extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      selectedPlan: undefined,
      plusPlan: undefined,
      elitePlan: undefined,
      essentialPlan: undefined,
      samplePolicyHref: undefined,
      apiFailureResponse: false,
      quoteData: undefined,
      showPaymentForm: false,
      showSuccessScreen: false,
      isSkipped: false,
    }
  }

  getSamplePolicy(state) {
    axios
    .processGet(
      `${ApiConstants.URL_GET_SAMPLE_POLICY}/${state}`
    )
    .then((response) => {
      this.setState({
        samplePolicyHref: response
      })
    })
  }

  getInsurancePlans() {
    LoadMask.showPreloader(this.refs.cRef);
    axios
      .processGet(
        `${ApiConstants.URL_GET_PLANS}/${this.props.microchipNumber}`
      )
      .then((response) => {
        let apiFailureResponse = false;
        let plans = response?.offers;
        let plusPlan = plans.find((offer) => offer.plan.toLowerCase() === 'plus');
        let essentialPlan = plans.find((offer) => offer.plan.toLowerCase() === 'essential');
        let elitePlan = plans.find((offer) => offer.plan.toLowerCase() === 'elite');

        if (!AppUtils.isEmptyString(response.noOffersReason)) {
          this.props.onJumpPage(5);
        }

        this.setState({
          plusPlan,
          essentialPlan,
          elitePlan,
          apiFailureResponse
        })
      })
      .catch((err) => {
        this.props.onJumpPage(5);
      })
      .finally(() => {
        LoadMask.hidePreloader(this.refs.cRef);
      })
  }

  componentDidMount() {
    // DataLayerUtils.createAccountEvent(
    //   this.props.type,
    //   'pre-verification success',
    //   'organic',
    //   this.props.formValues.microChipNumber
    // )

    // When mounted call the pricing API to get the plan list and details.
    this.getSamplePolicy(this.props.formValues.state);
    this.getInsurancePlans();
  }

  createQuote(plan) {
    LoadMask.showPreloader(this.refs.cRef);
    if (this.state.quoteData) {
      const payload = {
        petId: this.state.quoteData?.petId,
        planId: plan?.planId,
        deductible: plan?.deductible,
        reimbursement: plan?.reimbursement,
      }
      axios
      .processPost(
        `${ApiConstants.URL_POST_CHANGE_PLAN}`,
        null,
        payload
      )
      .then((response) => {
        if (AppUtils.isEmptyString(response.errorMessage)) {
          this.setState({
            showPaymentForm: true,
            quoteData: response
          })
        } else {
          this.setState({
            apiFailureResponse: true,
          })
        }
      })
      .finally(() => {
        LoadMask.hidePreloader(this.refs.cRef);
      })

      return;
    }

    axios
    .processPost(
      `${ApiConstants.URL_POST_CREATE_QUOTE}/${this.props.microchipNumber}`,
      null,
      plan
    )
    .then((response) => {
      if (AppUtils.isEmptyString(response.errorMessage)) {
        this.setState({
          showPaymentForm: true,
          quoteData: response
        })
      } else {
        this.setState({
          apiFailureResponse: true,
        })
      }
    })
    .finally(() => {
      LoadMask.hidePreloader(this.refs.cRef);
    })

  }

  sendQuote(plan) {
    const sendQuoteButtonEL = document.getElementById("send-quote-id");
    sendQuoteButtonEL.style.pointerEvents = 'none';
    showButtonLoader(sendQuoteButtonEL);
    axios
    .processPost(
      `${ApiConstants.URL_POST_SEND_QUOTE}`,
      null,
      plan
    )
    .then((response) => {
      hideButtonLoader(sendQuoteButtonEL)
    })
    .finally(() => {
      hideButtonLoader(sendQuoteButtonEL);
      sendQuoteButtonEL.style.pointerEvents = 'auto';
      this.props.onJumpPage(5);
    })
  }

  getPercentValue(value) {
    value = value * 100;
    return `${value}%`;
  }

  getSteps() {
    const steps = [
      {
        label: "Your Information",
        active: false,
        completed: true,
        onClick: (event) => {
          // this.props.onJumpPage(1);
        },
      },
      {
        label: "Pet Information",
        active: false,
        completed: true,
        onClick: (event) => {
          // this.props.onJumpPage(2);
        },
      },
      {
        label: "Review",
        active: true,
        onClick: (event) => {
          // this.props.onJumpPage(3);
        },
      }
    ];

    return steps;
  }

  backToPlanPage = (showSuccessPage = false) => {
    this.setState({
      showPaymentForm: false,
      showSuccessScreen: showSuccessPage,
    })
  }
    
  render() {
    return (
      <PageContent>
        <Steps
          steps={this.getSteps()}
          showSteps={this.props.formValues.showSteps}
        />
        <div ref="cRef">
          {!this.state.showPaymentForm && (<PetBestInsuranceCard
            petName={this.props.formValues.petName}
            email={this.props.formValues.email}
            samplePolicy={this.state.samplePolicyHref}
            showAPIFailureScreen={this.state.apiFailureResponse}
            showSuccessScreen={this.state.showSuccessScreen}
            selectedPlan={this.state.selectedPlan}
            isSkipped={this.state.isSkipped}
            emailInputProps={{
              disabled: true,
              value: this.props.formValues.email,
            }}
            essentialOptionProps={{
              price: AppUtils.getConvertedPrice(
                this.state.essentialPlan?.monthlyPremium
              ),
              plan: 'Essential',
              deductible: AppUtils.getConvertedPrice(
                this.state.essentialPlan?.deductible
              ),
              limit: 'Unlimited',
              reimbursement: this.getPercentValue(this.state.essentialPlan?.reimbursement),
              onClick: () => {
                this.setState({
                  selectedPlan: 'essential',
                  planInfo: this.state.essentialPlan
                });
              }
            }}
            plusOptionProps={{
              price: AppUtils.getConvertedPrice(
                this.state.plusPlan?.monthlyPremium
              ),
              plan: 'Plus',
              deductible: AppUtils.getConvertedPrice(
                this.state.plusPlan?.deductible
              ),
              limit: 'Unlimited',
              reimbursement: this.getPercentValue(this.state.plusPlan?.reimbursement),
              onClick: () => {
                this.setState({
                  selectedPlan: 'plus',
                  planInfo: this.state.plusPlan
                });
              }
            }}
            eliteOptionProps={{
              price: AppUtils.getConvertedPrice(
                this.state.elitePlan?.monthlyPremium
              ),
              plan: 'Elite',
              deductible: AppUtils.getConvertedPrice(
                this.state.elitePlan?.deductible
              ),
              limit: 'Unlimited',
              reimbursement: this.getPercentValue(this.state.elitePlan?.reimbursement),
              onClick: () => {
                this.setState({
                  selectedPlan: 'elite',
                  planInfo: this.state.elitePlan
                });
              }
            }}
            skipButtonProps={{
              onClick: () => {
                if (!this.state.isSkipped) {
                  this.setState({
                    isSkipped: true,
                  })
                } else {
                  this.props.onJumpPage(5);
                }
              }
            }}
            addButtonProps={{
              disabled: !this.state.selectedPlan,
              onClick: () => {
                this.createQuote(this.state.planInfo)
              }
            }}
            sendQuoteButtonProps={{
              id: 'send-quote-id',
              onClick: () => {
                const planDetails = this.state.planInfo || this.state.plusPlan;
                this.sendQuote(planDetails)
              }
            }}
            tryAgainButtonProps={{
              onClick: () => {
                this.getInsurancePlans();
              }
            }}
            reviewPageButtonProps={{
              onClick: () => {
                this.props.onJumpPage(5);
              }
            }}
          />)}
          {this.state.showPaymentForm && (<SpreedlyPayment
            planInfo={this.state.planInfo}
            quoteData={this.state.quoteData}
            formValues={this.props.formValues}
            goBack={this.backToPlanPage}
          />)}
        </div>
      </PageContent>
    );
  }
}

export default PetBestInsuranceComponent;